// App Configuration - Easy to customize for resale
export const APP_CONFIG = {
  // Bot Configuration - Change this when selling the project
  BOT_USERNAME: "PixelMinersbot", // Your bot username without @
  BOT_APP_URL: "https://t.me/PixelMinersbot/app", // Direct Mini App URL
  // Referral Configuration
  REFERRAL_REWARD_AMOUNT: 1000, // PXL reward for both referrer and referred user
  REFERRAL_REWARD: 1000, // Alias for easier access
  REFERRAL_CODE_PREFIX: "", // No prefix - use Telegram ID directly
  
  // Currency Configuration
  CURRENCY_SYMBOL: "PXL", // Currency symbol to display
  
  // App Details
  APP_NAME: "PXL App",
  APP_DESCRIPTION: "Mine PXL coins and invite friends",
  
  // Sharing Configuration
  SHARE_MESSAGE: "🎮 Join me in PXL App and start mining crypto! 💰\n\n🎁 Use my referral link to get 1000 PXL bonus!\n\n👇 Click here to start:",
  
  // Social Media Configuration
  TELEGRAM_SHARE_URL: "https://t.me/share/url",
  
  // Generate referral URL
  generateReferralUrl: (referralCode) => {
    return `${APP_CONFIG.BOT_APP_URL}?startapp=${referralCode}`;
  },
  
  // Generate Telegram share URL
  generateTelegramShareUrl: (referralCode) => {
    const referralUrl = APP_CONFIG.generateReferralUrl(referralCode);
    const message = encodeURIComponent(`${APP_CONFIG.SHARE_MESSAGE}\n\n${referralUrl}`);
    return `${APP_CONFIG.TELEGRAM_SHARE_URL}?url=${encodeURIComponent(referralUrl)}&text=${message}`;
  }
};

// Helper function to generate unique referral code (simplified - just use Telegram ID)
export const generateReferralCode = (userId) => {
  return userId.toString();
};

// Helper function to build referral URL
export const buildReferralUrl = (referralCode) => {
  return `${APP_CONFIG.BOT_APP_URL}?startapp=${referralCode}`;
};

export default APP_CONFIG;
